import type { DeliveryTypeOption } from '@src/clients/domain/Client';
import type {
  PrimaryDeliveryTypeValueField,
  SecondaryDeliveryTypeValueField,
} from '@src/permitField/PermitDeliveryAndNotificationsFields';

type FieldContext =
  | typeof PrimaryDeliveryTypeValueField.fieldName
  | typeof SecondaryDeliveryTypeValueField.fieldName;

export const fieldI18nKeyFrom = (
  fieldContext: FieldContext,
  deliveryType: DeliveryTypeOption,
) => {
  return `${fieldContext}.${deliveryType}`;
};
